<template>
  <v-input
    class="v-input v-input--is-label-active v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined"
    hide-details="auto"
    :error-messages="errorMessages"
  >
    <fieldset aria-hidden="true">
      <legend :style="{ width: `${legendWidth}px` }">
        <span class="notranslate">&ZeroWidthSpace;</span>
      </legend>
    </fieldset>
    <label
      :class="{
        'v-label': true,
        'v-label--active': true,
        'theme--light': true,
        'error--text': errorMessages.length
      }"
      style="right: auto; position: absolute"
    >
      {{ label }}
    </label>
    <slot />
  </v-input>
</template>

<script>
export default {
  props: {
    legendWidth: { type: Number, default: 0 },
    label: { type: String, default: '' },
    error: { type: String, default: '' }
  },
  computed: {
    errorMessages() {
      if (this.error) {
        return [this.error];
      }
      return [];
    }
  }
};
</script>
